import { setStorageItem } from "@v2/hooks/useLocalStorage";
import { createShallowStore } from "replo-utils/react/zustand";

const STORAGE_KEY = "replo.debug.adminPanel.visible";

function getIsVisible(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

function persistVisibility(value: boolean) {
  try {
    setStorageItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    // Silently ignore storage errors
  }
}

interface AdminPanelStore {
  isVisible: boolean;
  actions: {
    open: () => void;
    close: () => void;
    toggle: () => void;
  };
}

export const useAdminPanelStore = createShallowStore<AdminPanelStore>(
  (set) => ({
    isVisible: getIsVisible(),
    actions: {
      open: () => {
        persistVisibility(true);
        set({ isVisible: true });
      },
      close: () => {
        persistVisibility(false);
        set({ isVisible: false });
      },
      toggle: () => {
        set((state) => {
          const next = !state.isVisible;
          persistVisibility(next);
          return { isVisible: next };
        });
      },
    },
  }),
);

export const useAdminPanelActions = () => {
  return useAdminPanelStore((state) => state.actions);
};
